import {
  ChangeEvent,
  FunctionComponent,
  SyntheticEvent,
  useContext,
  useState,
} from "react";

import "./styles.scss";

//services
import { AuthService } from "../../services/auth";

//hooks
import { useAsync } from "../../utils/hooks/useAsync";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../../context/UserContext";
import Label from "../Label";
import Button from "../common/Button";

const ForgotPasswordContainer: FunctionComponent = ({}) => {
  const [email, setEmail] = useState("");
  const { isLoading, run } = useAsync();
  const { setUser, user } = useContext(UserContext);
  const navigate = useNavigate();

  const handleSubmit = (e: SyntheticEvent) => {
    e.preventDefault();
    run(AuthService.initiateResetPassword(email))
      .then((data: any) => {
        if (data.status !== 500) {
          setUser({ ...user, email: email });
          navigate("/confirm-password");
        }
      })
      .catch((err) => {
        console.log(err);
        throw new Error(err);
      });
  };

  return (
    <section className="forgot-password">
      <header>
        <Label tag="h1" className="forgot-password__title">
          Cambiar contraseña
        </Label>
      </header>
      <p className="forgot-password__subtitle">
        Recibirás un correo electrónico con un enlace para modificar tu
        contraseña. Si no recibes el correo, por favor, ponte en contacto con
        Rtabak.
      </p>
      <form className="forgot-password__form" onSubmit={handleSubmit}>
        <div>
          <label htmlFor="email" className="form__email--text">
            Email:
          </label>
          <input
            value={email}
            className="form__email--input"
            name="email"
            type="text"
            id="email"
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              setEmail(e.target.value)
            }
          />
        </div>
        <Button type="submit" isLoading={isLoading}>
          Solicitar cambio de contraseña
        </Button>
      </form>
      <p className="forgot-password__email">
        Si tienes alguna duda, envíanos un correo electrónico a{" "}
        <a
          href="mailto:forgot-password__email__bold"
          className="forgot-password__email__bold"
        >
          info@rtabak.com.ar
        </a>
        . Nos pondremos en contacto a la brevedad.
      </p>
    </section>
  );
};

export default ForgotPasswordContainer;
